import { Service, Reservation, ServiceBooking } from '@turizi/shared';
import { isRangeService } from '@/lib/models-utils';

export interface BookingPayloadParams {
    service: Service;
    adults: number;
    children: number;
    seniors: number;
    infants: number;
    guests: number;
    dates: [string | null, string | null];
    discount?: any;
    reservation?: Reservation | null;
}

export const generateBookingPayload = ({
    service,
    adults,
    children,
    seniors,
    infants,
    guests,
    dates,
    discount,
    reservation,
}: BookingPayloadParams) => {
    const isRange = isRangeService(service.category);
    let chosenStartDay = dates[0];
    if (!isRange && service?.availability?.days && dates[0] && dates[1]) {
        const totalPax = adults + children + seniors + guests;
        const firstDayLimit = service.availability.days[dates[0]];
        if (firstDayLimit !== null && firstDayLimit !== undefined && firstDayLimit < totalPax) {
            const availableEntry = Object.entries(service.availability.days).find(([d, limit]) => {
                if (d < dates[0]! || d > dates[1]!) return false;
                return limit === null || limit >= totalPax;
            });
            if (availableEntry) {
                chosenStartDay = availableEntry[0];
            }
        }
    }

    return {
        reservation_id: reservation?.id || null,
        service_id: service.id,
        seller_id: reservation?.seller_id || null,
        client_id_business: reservation?.client_id_business || null,
        adults,
        children,
        seniors,
        infants,
        guests,
        start_day: chosenStartDay,
        end_day: isRange ? dates[1] : null,
        self_attrs: service.booking_attrs,
        observations: '',
        discount_type: discount?.discount_type,
        discount_id: discount?.discount_id,
    };
};

export const sortServiceBookings = (bookings: ServiceBooking[]): ServiceBooking[] => {
    return [...bookings].sort((a, b) => {
        const dayA = a.start_day || '9999-99-99';
        const dayB = b.start_day || '9999-99-99';

        if (dayA !== dayB) {
            return dayA.localeCompare(dayB);
        }

        const hourA = a.start_hour || '99:99';
        const hourB = b.start_hour || '99:99';

        if (hourA !== hourB) {
            return hourA.localeCompare(hourB);
        }

        return a.id - b.id;
    });
};
